<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <input nbInput [formControl]="formControl" [formlyAttributes]="field" phoneMask>

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
